
import React, { Component } from 'react';
import {StyleSheet, Text, View, Animated, Easing, Image, Pressable, FlatList} from 'react-native';


import GameData from './GameData';

import TaskImages from './Images';

import { Ionicons } from 'react-native-vector-icons';

const fps = 60;
const fpsDuration = 1000/fps;
const fpsPecent = 1/fps;
const MYEPSILON = 0.0001;

class Inventory extends Component {
  constructor(props) {
    super(props);

	this.state = {
      inventory: {},
    }

  }
  
   componentDidMount() {
    this.interval = setInterval(function() {
			if (JSON.stringify(GameData.inventory) != JSON.stringify(this.state.inventory)) {
            	this.setState({inventory: Object.assign({}, GameData.inventory)});
			}
          }.bind(this), fpsDuration);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  } 

	mat

  renderInventory({item}) {
	  
    //return <Text style={styles.inventory}>{item}: {GameData.inventory[item]}</Text>
	// <Image style={styles.inventoryImage} source={TaskImages[item.toLowerCase()]} />
	/*
			<Ionicons
			style={styles.inventoryImage}
            name="md-arrow-up-outline"
            size={15}
            color={"#000000"}
          />
	*/
	return <View style={styles.inventoryRow}>
		<Image style={styles.inventoryImage} source={TaskImages[item.toLowerCase()]} />
		<Text style={styles.inventory}> {GameData.inventory[item]}</Text>
	</View>
  }

  render() {
	  //console.log(this.state.threat)
    return (
        <View style={styles.threatInventory}>
          <FlatList
            contentContainerStyle={{paddingLeft: 10, paddingRight: 10}}
            //columnWrapperStyle={{ alignItems: "flex-start" }}
            numColumns={10}
            scrollEnabled={false}
            data={Object.keys(GameData.inventory)}
            renderItem={this.renderInventory.bind(this)}
			//extraData={this.state}
          />
        </View>
    );
  }
}

const styles = StyleSheet.create({
  threatInventory: {
    borderBottomWidth: 2,
    width: '100%',
  },
  inventoryRow: {
	  flex: 1,
    flexDirection: 'row',
	//alignItems: 'center',
	justifyContent: 'center',
	alignContent: 'center',
	alignItems: 'center',
	alignSelf: 'center',
  },  
  inventoryImage: {
    height: 15,
    width: 15,
    alignSelf: 'center',
  },
  inventory: {
    fontSize: 16,
    //flex: 1,
	textAlign: 'center',
    fontFamily: 'Alegreya-Regular',
  },
});

export default Inventory;